import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
  },
  viewDetail: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: width * 0.04,
    borderTopColor: "#9cbee7",
    borderBottomWidth: 1,
    borderBottomColor: "#9cbee7",
    height: 147,
    alignItems: "center",
  },
  buttonRecords: {
    width: "20%",
    height: 59,
    backgroundColor: "#2B6AB1",
    borderRadius: 5,
    justifyContent: "center",
    marginLeft: 20,
  },
  textRecords: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
  imgDetail: {
    width: "100%",
    maxWidth: 120,
    height: 120,
    borderRadius: 5,
  },
  textTopicModal: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "16%",
  },
  textTopicModalRespons: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "16%",
  },
  textDetailModal: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    marginTop: 15,
    width: "16%",
  },
  textNameRecordModal: {
    fontSize: 22,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginLeft: 35,
    marginTop: 43,
    marginBottom: 13,
  },
  viewTopicRecordModal: {
    height: 60,
    marginHorizontal: 14.5,
    paddingHorizontal: 20,
    paddingBottom: 13.5,
    marginBottom: 13.5,
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomColor: "#2B6AB1",
    borderBottomWidth: 1,
    alignItems: "center",
  },
  viewRecordModal: {
    width: "80%",
    backgroundColor: "#FFFFFF",
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 38,
    borderRadius: 5,
    position: "absolute",
  },
  viewDetailModal: {
    flexDirection: "row",
    paddingHorizontal: 20,
    justifyContent: "space-between",
  },
  textTitle: {
    fontSize: 18,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  textTitleRespons: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: "10%",
  },
  viewTopic: {
    flexDirection: "row",
    marginTop: 27,
    paddingBottom: 10.5,
    width: "100%",
    paddingHorizontal: width * 0.04,
    justifyContent: "space-between",
  },
});
export const stylesResponsive = StyleSheet.create({
  textDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
  },
  textRecords: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
    textAlign: "center",
  },
  buttonRecords: {
    width: "20%",
    height: 59,
    backgroundColor: "#2B6AB1",
    borderRadius: 5,
    justifyContent: "center",
  },
  textTopicModal: {
    fontSize: 12,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
  },
  textDetailModal: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    textAlign: "center",
    width: width * 0.35,
  },
  textNameRecordModal: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    margin: 10,
  },
  viewTopicRecordModal: {
    height: 60,
    marginHorizontal: 14.5,
    paddingHorizontal: 20,
    paddingBottom: 13.5,
    marginBottom: 13.5,
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomColor: "#2B6AB1",
    borderBottomWidth: 1,
    alignItems: "center",
  },
  viewRecordModal: {
    maxWidth: 1249,
    width: "90%",
    backgroundColor: "#FFFFFF",
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 38,
    borderRadius: 5,
    paddingVertical: 20,
    position: "absolute",
  },
  viewTopicModal: {
    height: height * 0.1,
    borderRightWidth: 1,
    borderRightColor: "#2B6AB1",
    justifyContent: "center",
  },
  viewDetailModal: {
    height: height * 0.1,
    borderRightWidth: 1,
    borderRightColor: "#ccc",
    justifyContent: "center",
  },
});
